import axios from 'axios';
import { OnAuth0Logout } from 'functions/auth0Utils';

const apiClient = axios.create({
    headers: { "Content-Type": "application/json" },
});

export const InitializeInterceptors = (getAccessTokenSilently, logout) => {

    apiClient.interceptors.request.use(async (config) => {

        try {

            const token = await getAccessTokenSilently();

            config.headers.Authorization = `Bearer ${token}`;

            return config;

        } catch (error) {

            console.error("Error getting access token:", error);

            OnAuth0Logout(logout);

            return Promise.reject(error);

        }
    });

    apiClient.interceptors.response.use((response) => response, async (error) => {

        if (error.response?.status === 401) {

            try {

                const newToken = await getAccessTokenSilently();

                error.config.headers.Authorization = `Bearer ${newToken}`;

                return apiClient(error.config);

            } catch (refreshError) {

                console.error("Refresh token failed, logging out.");

                OnAuth0Logout(logout);
                
            }
        }

        return Promise.reject(error);

    });
};

export const WhichWeightAPI = async (SERVICE, METHOD, PATH, PARAMETERS = {}, options = {}) => {

    try {

        var baseURL = "";

        if (process.env.REACT_APP_NODE_ENV === "dev") {

            switch(SERVICE)
            {   
                case "BILLING": baseURL = 'http://localhost:4002'; break;
                case "CORE": baseURL = 'http://localhost:4003'; break;
                case "EMAIL": baseURL = 'http://localhost:4004'; break;
                case "PROGRAM": baseURL = 'http://localhost:4005'; break;
                case "RECOMMENDATION": baseURL = 'http://localhost:4006'; break;
                case "REPORTING": baseURL = 'http://localhost:4007'; break;
                default: throw new Error(SERVICE + " is not a valid service for WhichWeightAPI!");
            }

        }

        if (process.env.REACT_APP_NODE_ENV === "test") {

            switch(SERVICE)
            {   
                case "BILLING": baseURL = 'https://test-billing.whichweight.com'; break;
                case "CORE": baseURL = 'https://test-core.whichweight.com'; break;
                case "EMAIL": baseURL = 'https://test-email.whichweight.com'; break;
                case "PROGRAM": baseURL = 'https://test-program.whichweight.com'; break;
                case "RECOMMENDATION": baseURL = 'https://test-recommendation.whichweight.com'; break;
                case "REPORTING": baseURL = 'https://test-reporting.whichweight.com'; break;
                default: throw new Error(SERVICE + " is not a valid service for WhichWeightAPI!");
            }

        }

        if (process.env.REACT_APP_NODE_ENV === "prod") {

            switch(SERVICE)
            {   
                case "BILLING": baseURL = 'https://billing.whichweight.com'; break;
                case "CORE": baseURL = 'https://core.whichweight.com'; break;
                case "EMAIL": baseURL = 'https://email.whichweight.com'; break;
                case "PROGRAM": baseURL = 'https://program.whichweight.com'; break;
                case "RECOMMENDATION": baseURL = 'https://recommendation.whichweight.com'; break;
                case "REPORTING": baseURL = 'https://reporting.whichweight.com'; break;
                default: throw new Error(SERVICE + " is not a valid service for WhichWeightAPI!");
            }

        }

        // console.log(PARAMETERS)
        // console.log(baseURL + PATH)

        return await apiClient({
            method: METHOD,
            url: baseURL + PATH,
            params: METHOD === "GET" ? PARAMETERS : undefined,
            data: METHOD !== "GET" ? PARAMETERS : undefined,
            signal: options?.signal // Pass through the abort signal if provided
        });

    } catch (error) {
        
        // If the request was aborted, throw the error so it can be handled by the caller
        if (error.name === 'CanceledError') {
            throw error;
        }

        console.error("There was an error with WhichWeightAPI: ", error);
        return "failure";
        
    }

}